import { render, staticRenderFns } from "./FormAlarmLimitSensorMCA.vue?vue&type=template&id=684fee37&scoped=true"
import script from "./FormAlarmLimitSensorMCA.vue?vue&type=script&lang=ts"
export * from "./FormAlarmLimitSensorMCA.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684fee37",
  null
  
)

export default component.exports